import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@nosible/shared/lib/utils";

const badgeVariants = cva(
  "inline-flex items-center rounded-md border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-neon-green text-obsidian shadow hover:bg-neon-green/80",
        secondary:
          "border-transparent bg-slate-core text-silica hover:bg-slate-core/80",
        destructive:
          "border-transparent bg-red-500 text-white shadow hover:bg-red-500/80",
        outline: "text-chromium-mist border-slate-core",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
  VariantProps<typeof badgeVariants> { }

function Badge({ className, variant, ...props }: BadgeProps) {
  const resolvedVariant = variant ?? "default";

  return (
    <div
      data-slot="badge"
      data-variant={resolvedVariant}
      className={cn(badgeVariants({ variant }), className)}
      {...props}
    />
  );
}

export { Badge, badgeVariants };
